<template>
  <div
    class="relative w-full container h-max rounded-[48px] p-6 bg-white overflow-hidden shadow-xl"
  >
    <div class="relative rounded-3xl overflow-hidden">
      <img
        src="/landing/images/dashboard.webp"
        alt="Saraf Robot dashboard"
        class="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
